export default __webpack_public_path__ + "static/media/HeroVideo.c40a30e2.mp4";